/*
Sohel 03/21/2023 2699762545 Added letter Group Screen
Sohel 03/25/2023 2699762545 removed extra payload
Sohel 03/27/2023 2699762545 Payload Changes
Dilip 03/27/2023 2699762545 added bredcrums to show code and description
Akhila 03/27/2023 2699762545 Added save button
Prakash 03/27/2023 2699762545 Added class name for table.
Ravi 04/12/2023 2699762545 Added unsaved popup changes
Akhila 05/24/2024 2699762545 role access implemeneted
Akhila 06/01/2023 2699762545 disabled save and next button if no data
Ravi 06/20/2023 2699762545 Added Breadcrum in popup
Ravi 06/20/2023 2699762545 removed Breadcrum in popup
Ravi 06/21/2023 2699762545 fixed submit issue
*/
import React, {useEffect, useState, useRef} from 'react';
import {Formik, FieldArray, Field, Form} from 'formik';
import {Button} from '@material-ui/core';
import BreadCrums from '../../../util/BreadCrum';
import {useDispatch, useSelector} from 'react-redux';
import DialogBox from '../../../components/DialogBox';
import OrganizationFieldsTable from './Organization/OrganizationFieldsTable';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {Add} from '@material-ui/icons';
import OrganizationForm from './Organization/OrganizationForm';
import reusableInputStyles from '../../../components/InputStyles';
import {
  fetchClientInformationData,
  postClientInformation,
  resetBasicInfo,
} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
const ClientInformation = ({
  handleBack,
  handleNext,
  handleDirty,
  editExisting,
  LetterMainAccess,
}) => {
  const classes = reusableInputStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [rowData, setRowData] = useState({});
  const initialState = {
    organizationFields: [],
    priorLetters: [],
  };
  const {
    letterCode,
    isBasicInfoLoading,
    basicInfoSuccessMsg,
    basicInfoErrorMsg,
    basicInfoStatus,
    clientInformationData,
    basicInfoData,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const [initialValues, setInitialValues] = useState(initialState);
  const [deletedIds, setDeletedIds] = useState([]);
  const dispatch = useDispatch();
  const saveRef = useRef(false);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const handleClose = () => {
    setIsOpen(false);
    setIsEdit(false);
  };
  const dmArrayHelpers = useRef();
  const formRef = useRef();

  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Organization Type',
    },
    {
      title: 'Organization Code',
    },
  ];
  useEffect(() => {
    const organization =
      clientInformationData?.letterOrganizationRequests?.length > 0 ?
        clientInformationData?.letterOrganizationRequests?.map((el) => {
          return {
            ...el,
            organizationCode: el?.orgCode,
            organizationType: el?.orgType,
          };
        }) :
        [];

    setInitialValues({
      ...initialValues,
      organizationFields: organization,
    });
  }, [clientInformationData]);
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const clientInformation =
      values?.organizationFields?.length > 0 ?
        values?.organizationFields?.map((el) => {
          return {
            letterClientId: el?.letterClientId ? el?.letterClientId : 0,
            letterCode: letterCode,
            orgCode: el?.organizationCode,
            orgType: el?.organizationType,
          };
        }) :
        [];
    const payload = {
      deleteClientIds: deletedIds?.length > 0 ? [...new Set(deletedIds)] : [0],
      letterCode: letterCode,
      isDraft: basicInfoData?.isDraft === 'N' ? 'N' : 'Y',
      lastStep: basicInfoData?.lastStep > 2 ? basicInfoData?.lastStep : 2,
      letterOrganizationRequests: clientInformation,
    };

    dispatch(postClientInformation(payload));
  };
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
        if (basicInfoSuccessMsg && basicInfoStatus === 200 && !saveRef.current) {
          handleNext();
        } else if (basicInfoSuccessMsg && basicInfoStatus === 200 && saveRef.current) {
          dispatch(fetchClientInformationData(letterCode));
        }
      }, 2000);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg, basicInfoStatus]);
  useEffect(() => {
    if (letterCode) {
      dispatch(fetchClientInformationData(letterCode));
    }
  }, [letterCode]);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
        innerRef={formRef}
      >
        {(props) => {
          const {
            values,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              {/* <div className="mb-4">
                <BreadCrums
                  name={"Letter Code"}
                  code={basicInfoData?.letterCode}
                  description={"Letter Description"}
                  descriptionValue={basicInfoData?.letterDescription}
                />
              </div> */}
              <Form noValidate>
                <FieldArray
                  name="organizationFields"
                  render={(arrayHelpers) => {
                    dmArrayHelpers.current = arrayHelpers;
                    return (
                      <>
                        <div className="table-header justify-content-between new-standard-textfields">
                          <div>
                            <BreadCrums
                              name={'Letter Code'}
                              code={basicInfoData?.letterCode}
                              description={'Letter Description'}
                              descriptionValue={basicInfoData?.letterDescription}
                            />
                          </div>
                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            disabled={editExisting && !LetterMainAccess?.edit}
                            onClick={() => {
                              setIsOpen(true);
                            }}
                            startIcon={<Add />}
                          >
                            Add
                          </Button>
                        </div>
                        <div
                          className={
                            'mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields'
                          }
                        >
                          <table>
                            <thead className="recFormat-header-container">
                              <tr>
                                {columns.map(
                                  ({title, hidden = false}) =>
                                    !hidden && (
                                      <th key={title} className="recFormat-header">
                                        {title}
                                      </th>
                                    ),
                                )}
                              </tr>
                            </thead>
                            {values.organizationFields?.length > 0 ? (
                              <tbody className="recFormat-body">
                                {values.organizationFields.map((field, index) => (
                                  <>
                                    <Field
                                      key={field.organizationType + field.organizationCode}
                                      name={`organizationFields[${index}]`}
                                      component={OrganizationFieldsTable}
                                      index={index}
                                      columns={columns}
                                      dmArrayHelpers={dmArrayHelpers}
                                      deletedIds={deletedIds}
                                      setDeletedIds={setDeletedIds}
                                      setIsEdit={setIsEdit}
                                      setRowData={setRowData}
                                      editExisting={editExisting}
                                      LetterMainAccess={LetterMainAccess}
                                    />
                                  </>
                                ))}
                              </tbody>
                            ) : (
                              <tbody>
                                <tr>
                                  <td colSpan={columns.length}>{'No records to display'}</td>
                                </tr>
                              </tbody>
                            )}
                          </table>
                        </div>
                        <DialogBox
                          open={isOpen || isEdit}
                          dialogClose={handleClose}
                          title={isEdit ? 'Edit Organization' : 'Add Organization'}
                          maxWidth="md"
                        >
                          <OrganizationForm
                            OrganizationValues={values}
                            setOrganizationValues={setFieldValue}
                            rowData={rowData}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            setIsOpen={setIsOpen}
                            handleDirty={handleDirty}
                          />
                        </DialogBox>
                      </>
                    );
                  }}
                />
                {/* <div className="mt-3">
                  <FieldArray
                    name="priorLetters"
                    render={(arrayHelpers) => {
                      priorArrayHelpers.current = arrayHelpers;
                      return (
                        <>
                          <div className="table-header justify-content-end new-standard-textfields">
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                setIsPrior(true);
                              }}
                              startIcon={<Add />}
                            >
                              Prior Letters
                            </Button>
                          </div>
                          <div
                            className={
                              "mui-custom-table-container custom-table  pt-0 global-field-table text-center-table"
                            }
                          >
                            <table>
                              <thead className="recFormat-header-container">
                                <tr>
                                  {letterColumns.map(
                                    ({ title, hidden = false }) =>
                                      !hidden && (
                                        <th key={title} className="recFormat-header">
                                          {title}
                                        </th>
                                      )
                                  )}
                                </tr>
                              </thead>
                              {values.priorLetters?.length > 0 ? (
                                <tbody className="recFormat-body">
                                  {values.priorLetters.map((field, index) => (
                                    <>
                                      <Field
                                        key={field.letterCode}
                                        name={`priorLetters[${index}]`}
                                        component={PriorLettersTable}
                                        index={index}
                                        columns={columns}
                                        priorArrayHelpers={priorArrayHelpers}
                                        lettersDeletedIds={lettersDeletedIds}
                                        setLettersDeletedIds={setLettersDeletedIds}
                                      />
                                    </>
                                  ))}
                                </tbody>
                              ) : (
                                <tbody>
                                  <tr>
                                    <td colSpan={columns.length}>{"No records to display"}</td>
                                  </tr>
                                </tbody>
                              )}
                            </table>
                          </div>
                          <DialogBox
                            open={isPrior}
                            dialogClose={handlePriorClose}
                            title={"Search Prior Letters"}
                            maxWidth="xl"
                          >
                            <LetterMaintenanceSearchTable
                              isPriorLetters={true}
                              lettersValues={values}
                              setTempSelectedRows={setTempSelectedRows}
                              tempSelectedRows={tempSelectedRows}
                              handlePriorClose={handlePriorClose}
                              setLettersValues={setFieldValue}
                              lettersDeletedIds={lettersDeletedIds}
                              setLettersDeletedIds={setLettersDeletedIds}
                            />
                          </DialogBox>
                        </>
                      );
                    }}
                  />
                </div> */}
                <div className="d-flex justify-content-center mt-3 new-standard-textfields">
                  <Button
                    onClick={() => {
                      handleBack();
                    }}
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {basicInfoData?.isDraft === "N" && ( */}
                  <Button
                    variant="outlined"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    disabled={
                      (editExisting && !LetterMainAccess?.edit) ||
                        values?.organizationFields?.length === 0 ||
                        enabledSubmission
                    }
                    onClick={() => {
                      handleSubmit();
                      saveRef.current = true;
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  <Button
                    variant="outlined"
                    // type="submit"
                    disabled={
                      (editExisting && !LetterMainAccess?.edit) ||
                      values?.organizationFields?.length === 0 ||
                      enabledSubmission
                    }
                    onClick={() => {
                      saveRef.current = false;
                      handleSubmit();
                    }}
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  >
                    Save & Next
                  </Button>
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
};

export default ClientInformation;
